import { AnyAction } from 'redux';
import Page from 'shared/types/Page'

interface MenuPagesState {
    pages: Page[]
}

const noMenuPages: MenuPagesState = {
    'pages': []
};

const menuPages = (state = noMenuPages, action: AnyAction) => {
    switch (action.type) {
        case 'SET_MENU_PAGES':
          
            const newState = {
                pages: action.pages
            }

            return {
                ...state,
                ...newState
            }
            
        default:
            return state
    }
}
  
  export default menuPages;